"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CertificatesFetcher = void 0;

var tslib_1 = require("tslib");

var Plugin_1 = require("@skbkontur/plugin-js/lib/Plugin");

var Log_1 = require("@skbkontur/plugin-js/lib/common/Log");

var Timer_1 = require("@skbkontur/plugin-js/lib/common/Timer");

var Diagnostic_1 = require("@skbkontur/plugin-js/lib/Diagnostic/Diagnostic");

var _uniqBy = require("lodash/uniqBy");

var _sortBy = require("lodash/sortBy");

var constants_1 = require("../../utils/constants");

var CertificatesFetcher =
/** @class */
function () {
  function CertificatesFetcher(options) {
    var _this = this;

    this.options = options;
    this.active = false;
    this.completed = false;
    this.timeoutId = 0;
    this.iterationIndex = 0;
    this.log = Log_1.LogManager.getLog(constants_1.LOG_PREFIX + "CertificatesFetcher");

    this.start = function () {
      _this.log.info('Start certificate fetching');

      _this.active = true;

      _this.fetchIteration();
    };

    this.stop = function () {
      _this.log.info('Stop certificate fetching');

      clearTimeout(_this.timeoutId);
      _this.active = false;
      _this.iterationIndex = 0;
    };

    this.isActive = function () {
      return _this.active;
    };

    this.isCompleted = function () {
      return _this.completed;
    };

    this.setPluginInfo = function (pluginSetupResult) {
      _this.options.pluginSetupResult = pluginSetupResult;
    };

    this.fetchIteration = function () {
      return tslib_1.__awaiter(_this, void 0, void 0, function () {
        var certificateInfos, pluginSetupResult, items, visibleItems, storeTypeSupportCertInstall, installedCertificates, installedItems, installedCertificates, installedItems, error_1;

        var _this = this;

        return tslib_1.__generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              this.log.info("Certificates fetch iteration " + this.iterationIndex++);

              if (!this.active) {
                return [2
                /*return*/
                ];
              }

              _a.label = 1;

            case 1:
              _a.trys.push([1, 12,, 13]);

              return [4
              /*yield*/
              , this.getCertificates()];

            case 2:
              certificateInfos = _a.sent();

              if (!this.active) {
                return [2
                /*return*/
                ];
              }

              pluginSetupResult = this.options.pluginSetupResult;
              return [4
              /*yield*/
              , this.options.certificateProcessor.process(certificateInfos)];

            case 3:
              items = _a.sent();
              visibleItems = this.options.certificateProcessor.getVisibleItems(items);
              storeTypeSupportCertInstall = this.options.storeTypes.includes(Plugin_1.StoreType.CryptoApi);
              if (!(pluginSetupResult && visibleItems.length === 0 && pluginSetupResult.flags.InstallCertificate && storeTypeSupportCertInstall && this.options.installParams)) return [3
              /*break*/
              , 6];
              this.log.info('Visible certificates not found. Trying to start certificates installation');
              return [4
              /*yield*/
              , this.installCertificates(items.map(function (item) {
                return item.certificate.thumbprint();
              }), false)];

            case 4:
              installedCertificates = _a.sent();
              if (!installedCertificates.length) return [3
              /*break*/
              , 6];
              return [4
              /*yield*/
              , this.options.certificateProcessor.process(installedCertificates)];

            case 5:
              installedItems = _a.sent();
              items = items.concat(installedItems);
              _a.label = 6;

            case 6:
              return [4
              /*yield*/
              , this.options.onIterationComplete(items)];

            case 7:
              _a.sent();

              if (!(pluginSetupResult && visibleItems.length && pluginSetupResult.flags.InstallWithoutPasswordRequest && storeTypeSupportCertInstall && this.options.installParams && this.options.installParams.always)) return [3
              /*break*/
              , 11];
              this.log.info('Found visible certificates. Trying to install additional certificates');
              return [4
              /*yield*/
              , this.installCertificates(items.map(function (item) {
                return item.certificate.thumbprint();
              }), true)];

            case 8:
              installedCertificates = _a.sent();
              return [4
              /*yield*/
              , this.options.certificateProcessor.process(installedCertificates)];

            case 9:
              installedItems = _a.sent();
              if (!installedItems.length) return [3
              /*break*/
              , 11];
              items = items.concat(installedItems);
              return [4
              /*yield*/
              , this.options.onIterationComplete(items)];

            case 10:
              _a.sent();

              _a.label = 11;

            case 11:
              this.timeoutId = window.setTimeout(function () {
                _this.fetchIteration();
              }, this.options.fetchPeriod);
              return [3
              /*break*/
              , 13];

            case 12:
              error_1 = _a.sent();
              this.options.onError(error_1);
              return [3
              /*break*/
              , 13];

            case 13:
              return [2
              /*return*/
              ];
          }
        });
      });
    };

    this.getCertificates = function () {
      var _a = _this.options,
          pluginSetupResult = _a.pluginSetupResult,
          storeNames = _a.storeNames,
          storeTypes = _a.storeTypes,
          fetchCertificatesWithContent = _a.fetchCertificatesWithContent,
          hasPrivateKey = _a.hasPrivateKey,
          pluginRequestTimeout = _a.pluginRequestTimeout; // console.timeEnd('P_PluginSetup');
      // console.time('P_GetCertificates');

      var arPromise = [];

      if (pluginSetupResult && storeTypes.includes(Plugin_1.StoreType.CryptoApi)) {
        storeNames.forEach(function (name) {
          Timer_1.Timer.start("CryptoApi_" + name + "_Certs");
        });
        arPromise.push(Promise.all(storeNames.map(function (name) {
          return pluginSetupResult.plugin.searchCertificate({
            store: {
              name: name
            },
            hasPrivateKey: hasPrivateKey,
            timeout: pluginRequestTimeout
          }, {
            content: fetchCertificatesWithContent
          }).then(function (certificates) {
            _this.certsMetrics(certificates, "CryptoApi_" + name + "_Certs");

            _this.log.info("Fetched certificates from cryptoApi:" + name, certificates);

            return certificates.map(function (certificate) {
              return {
                certificate: certificate,
                storeInfo: {
                  type: Plugin_1.StoreType.CryptoApi,
                  name: name
                }
              };
            });
          });
        })).then(function (items) {
          return [].concat.apply([], items); // items.flat(); polyfill
        }));
      } else {
        arPromise.push(Promise.resolve([]));
      }

      if (pluginSetupResult && pluginSetupResult.flags.StoreType && storeTypes.includes(Plugin_1.StoreType.Pkcs11)) {
        Timer_1.Timer.start('Pkcs11Certs');
        arPromise.push(pluginSetupResult.plugin.searchCertificate({
          store: {
            type: Plugin_1.StoreType.Pkcs11
          },
          timeout: pluginRequestTimeout
        }, {
          content: fetchCertificatesWithContent,
          hasPrivateKey: false
        }).then(function (certificates) {
          _this.certsMetrics(certificates, 'Pkcs11Certs');

          _this.log.info("Fetched certificates from pkcs11", certificates);

          return certificates.map(function (certificate) {
            return {
              certificate: certificate,
              storeInfo: {
                type: Plugin_1.StoreType.Pkcs11
              }
            };
          });
        }));
      } else {
        arPromise.push(Promise.resolve([]));
      }

      if (storeTypes.includes(Plugin_1.StoreType.Requisite)) {
        var _b = _this.options,
            requisiteCertificateTypes = _b.requisiteCertificateTypes,
            ntrClient = _b.ntrClient;
        var type = requisiteCertificateTypes.length ? requisiteCertificateTypes.join(',') : undefined;
        arPromise.push(ntrClient.getUserCertificates(type).then(function (certificates) {
          return certificates.map(function (certificate) {
            return {
              certificate: certificate,
              storeInfo: {
                type: Plugin_1.StoreType.Requisite
              }
            };
          });
        }).catch(function () {
          return [];
        }));
      } else {
        arPromise.push(Promise.resolve([]));
      }

      if (storeTypes.includes(Plugin_1.StoreType.CACabinet)) {
        var caCabinetClient = _this.options.caCabinetClient;
        arPromise.push(caCabinetClient.getUserCertificates().then(function (certificates) {
          return certificates.map(function (certificate) {
            return {
              certificate: certificate,
              storeInfo: {
                type: Plugin_1.StoreType.CACabinet
              }
            };
          });
        }).catch(function () {
          return [];
        }));
      } else {
        arPromise.push(Promise.resolve([]));
      }

      return Promise.all(arPromise).then(function (result) {
        var cryptoApiCerts = result[0],
            pkcs11Certs = result[1],
            requisiteCerts = result[2],
            caCabinetCerts = result[3];
        var order = [Plugin_1.StoreType.CryptoApi, Plugin_1.StoreType.Pkcs11, Plugin_1.StoreType.Requisite, Plugin_1.StoreType.CACabinet]; // Массивы указаны в порядке приоритета данных

        var filteredItems = _uniqBy(tslib_1.__spreadArrays(caCabinetCerts, pkcs11Certs, cryptoApiCerts, requisiteCerts), function (item) {
          return item.certificate.thumbprint();
        }); // Данные возвращаются в порядке заданном в переменной order


        var sortedItems = _sortBy(filteredItems, function (item) {
          return order.findIndex(function (type) {
            return type === item.storeInfo.type;
          });
        }); // console.timeEnd('P_GetCertificates');
        // console.time('P_ProcessCerts');


        return sortedItems;
      });
    };

    this.certsMetrics = function (certificates, label) {
      var duration = Timer_1.Timer.finish(label);

      if (certificates.length) {
        _this.options.trackEvent(label + "Count", certificates.length.toString(), {
          duration: duration
        });
      }
    };

    this.installCertificates = function (existingCertThumbprints, visibleCertificatesExist) {
      return tslib_1.__awaiter(_this, void 0, void 0, function () {
        var _a, longInstallationTimeout, onStart, onFinish, validIssuers, onStartInternal, actionName, installedCertificates, diag, containerCertInfos, newContainerCertInfos, longInstallTask, result, error_2;

        var _this = this;

        return tslib_1.__generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              _a = this.options.installParams, longInstallationTimeout = _a.longInstallationTimeout, onStart = _a.onStart, onFinish = _a.onFinish, validIssuers = _a.validIssuers, onStartInternal = _a.onStartInternal;
              actionName = "certInstall" + (visibleCertificatesExist ? 'ListNotEmpty' : 'EmptyList');
              installedCertificates = [];
              diag = new Diagnostic_1.Diagnostic({
                plugin: this.options.pluginSetupResult.plugin
              });

              if (onStart) {
                onStart();
              }

              _b.label = 1;

            case 1:
              _b.trys.push([1, 6, 7, 8]);

              return [4
              /*yield*/
              , diag.searchCertsInCryptoProContainers()];

            case 2:
              containerCertInfos = _b.sent();
              this.log.info('Private key containers with certificates', containerCertInfos);
              newContainerCertInfos = _uniqBy(containerCertInfos, function (_a) {
                var certificate = _a.certificate;
                return certificate.thumbprint();
              }).filter(function (containerCertInfo) {
                return !existingCertThumbprints.includes(containerCertInfo.certificate.thumbprint());
              }).filter(function (containerCertInfo) {
                return validIssuers.length === 0 || validIssuers.includes(containerCertInfo.certificate.issuer());
              });
              if (!newContainerCertInfos.length) return [3
              /*break*/
              , 4];
              this.log.info('Found new valid certificates in private key containers', newContainerCertInfos, 'Start certificates installation');
              this.options.trackEvent(actionName, 'start', {
                existingCertsCount: existingCertThumbprints.length
              });
              this.options.trackEvent(actionName, 'startCertsReadyToInstall', {
                containerWithCertsCount: newContainerCertInfos.length
              });
              longInstallTask = window.setTimeout(function () {
                _this.log.warn("Certificates installing takes too much time " + longInstallationTimeout + "ms");

                _this.options.trackEvent(actionName, 'longInstallation', {
                  loginTimeoutValue: longInstallationTimeout
                });
              }, longInstallationTimeout);

              if (onStartInternal) {
                onStartInternal();
              }

              return [4
              /*yield*/
              , diag.installCertsFromContainers(newContainerCertInfos, {
                storeName: Plugin_1.StoreName.My,
                storeLocation: Plugin_1.StoreLocation.User,
                force: false
              })];

            case 3:
              result = _b.sent();
              installedCertificates = result.filter(function (r) {
                return r.installed;
              }).map(function (r) {
                return r.certificate;
              });
              window.clearTimeout(longInstallTask);
              this.log.info('Certificates has been installed', installedCertificates, 'Finish certificates installing');
              this.options.trackEvent(actionName, 'finish', {
                installedCertsCount: installedCertificates.length
              });
              return [3
              /*break*/
              , 5];

            case 4:
              this.log.info('There are no new valid certificates in private key containers. Finish certificates installing');
              _b.label = 5;

            case 5:
              return [3
              /*break*/
              , 8];

            case 6:
              error_2 = _b.sent();
              this.log.error('Error during certificates installing', error_2.message, error_2);
              this.options.trackEvent(actionName, 'error', {
                errorCode: error_2.code || 'unknownError',
                errorMessage: error_2.message
              });
              return [3
              /*break*/
              , 8];

            case 7:
              if (onFinish) {
                onFinish();
              }

              return [7
              /*endfinally*/
              ];

            case 8:
              return [2
              /*return*/
              , installedCertificates.map(function (certificate) {
                return {
                  certificate: certificate,
                  storeInfo: {
                    storeName: Plugin_1.StoreName.My,
                    type: Plugin_1.StoreType.CryptoApi
                  }
                };
              })];
          }
        });
      });
    };
  }

  return CertificatesFetcher;
}();

exports.CertificatesFetcher = CertificatesFetcher;